import axios, { CancelToken } from 'axios';
import { getToken } from '../../../token';
import { urlHttpGov } from '../../../request/urls';
import { IConfiguracaoGeralProposta, IUpdateConfiguracaoGeralPayload } from '../../../../pages/Propostas/interface';

class ConfiguracaoGeralPropostaService {
    private readonly baseURL = `${urlHttpGov}/proposta-comercial/configuracao-geral`;

    private getHeaders() {
        return {
            Authorization: `Bearer ${getToken()}`
        };
    }

    async get(signal?: CancelToken): Promise<IConfiguracaoGeralProposta> {
        const { data } = await axios.get(`${this.baseURL}`, {
            headers: this.getHeaders(),
            cancelToken: signal
        });
        return data;
    }

    async update(payload: IUpdateConfiguracaoGeralPayload): Promise<IConfiguracaoGeralProposta> {
        const { data } = await axios.put(`${this.baseURL}`, payload, {
            headers: this.getHeaders()
        });
        return data;
    }
}

export default new ConfiguracaoGeralPropostaService();
